import PortalConfigComponent from '../Components/Growth/PortalConfigComponent';

function PortalConfigPage() {
  return <PortalConfigComponent />;
}

export default PortalConfigPage;
